import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getPrivacyPolicyLink } from 'utils';

export const PrivacyPolicy = () => {
  const { t: translate } = useTranslation('account');
  const privacyUrl = getPrivacyPolicyLink();

  return (
    <Trans
      t={translate}
      i18nKey="notification_preference_centre.privacy_policy.text"
      defaults="By selecting your preferences above you are consenting to receive communications from {{brandName}}. Learn about our <styled_link>Privacy Policy</styled_link>"
      components={{
        styled_link: (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer"></a>
        ),
      }}
    />
  );
};
